//mushroom-guest-access-page.tsx

import React, { useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import {
  isMushroomGuestEnabled,
  setMushroomGuestSession,
  validateMushroomGuestCode,
} from "../mushroom/guest/mushroom-guest-session";

export default function MushroomGuestAccessPage() {
  const history = useHistory();
  const [code, setCode] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    setError("");

    if (!isMushroomGuestEnabled()) {
      setError("Guest access is not enabled.");
      return;
    }

    if (!validateMushroomGuestCode(code)) {
      setError("Incorrect access code.");
      return;
    }

    setMushroomGuestSession();
    history.push("/mushroom/home/board");
  };

  return (
    <Box sx={{ p: 3, maxWidth: 520, mx: "auto" }}>
      <Typography sx={{ fontSize: 22, fontWeight: 700, mb: 1 }}>
        Mushroom Mode – Guest Access
      </Typography>
      <Typography sx={{ mb: 2 }}>
        Enter the access code to view staging in read-only mode.
      </Typography>

      <TextField
        fullWidth
        label="Access Code"
        value={code}
        onChange={(e) => setCode(e.target.value)}
        error={!!error}
        helperText={error || " "}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleSubmit();
          }
        }}
      />

      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" onClick={handleSubmit}>
          Continue
        </Button>
      </Box>
    </Box>
  );
}
